import Bowser from "bowser";

export const clientEnvIsAndroid = () => {
  if (!window.navigator.userAgent) return false;
  return Bowser.getParser(window.navigator.userAgent).getOSName(true) === "android";
};
